<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "common/stylus/base.styl"

</style>



// WEBPACK FOOTER //
// App.vue?3986a1d5